module.exports = __webpack_public_path__ + "img/1491176296.de78a1d8.jpg";